<!--
	@component
	Self-contained toggle for the "LetsGo" mail setting.
-->
<script lang="ts">
	import { t } from '$i18n/i18n'
	import Switch from '$lib/atoms/Switch.svelte'
	import Tooltip from '$lib/atoms/Tooltip.svelte'
	import { TooltipPlacements } from '$lib/types/enums'
	import { saveLetsGoMailSetting } from './LotAccountingMailConfiguration.controller'

	let {
		shouldSendLetsGoMail = $bindable(true),
		disabled,
		lotId
	}: {
		shouldSendLetsGoMail?: boolean
		disabled: boolean
		lotId: string
	} = $props()
</script>

<div class="manage-mail-container">
	<div class="lets-go-mail">
		<span>
			{$t('UI.mail.config.manage.mail')}
		</span>
		<div class="context">
			<div class="switch-container">
				{#if disabled}
					<Tooltip
						msg={$t('UI.mail.config.disabled.ttText')}
						placementTtip={TooltipPlacements.BOTTOM_START}
					>
						<Switch checked={shouldSendLetsGoMail} disabled />
					</Tooltip>
				{:else}
					<!--
						The native 'change' event from the checkbox inside Switch bubbles here.
						Programmatic updates (from API load) do not fire native DOM events,
						so this handler only fires on actual user interactions.
					-->
					<div onchange={() => void saveLetsGoMailSetting(lotId)}>
						<Switch bind:checked={shouldSendLetsGoMail} />
					</div>
				{/if}
			</div>
			<div>
				<p class="definition">{$t('UI.mail.config.letsGo.mail')}</p>
				<p class="info-text">{$t('UI.mail.config.letsGo.mail.infoText')}</p>
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import '../../../styles/global';

	.manage-mail-container {
		width: 100%;
		margin-top: 2rem;

		@include flex-col($justify: flex-start, $alignment: flex-start);

		& .lets-go-mail {
			margin-top: 1.75rem;
			margin-bottom: 3rem;
			text-align: start;

			& span {
				@include roboto-font(normal, 400, 1.25rem, black);
			}

			& .context {
				@include flex-row($alignment: baseline, $justify: center);

				margin-top: 1.2rem;

				& .definition {
					@include roboto-font(1.125rem, 400, 0.875rem, black);

					margin-bottom: 0.375rem;
					flex: none;
				}

				& .info-text {
					@include roboto-font(1rem, 400, 0.875rem, black);

					flex: none;
					opacity: 0.5;
					max-width: 21.875rem;
				}

				& .switch-container {
					align-self: flex-start;
					margin-right: 2rem;
					width: auto;
				}
			}
		}
	}
</style>
